import React from "react"
import { RadioBox } from "./helper";
import { Translate } from "react-localize-redux";

const ans = [
    'T',
    'B',
    'T',
    'B',
    'R',
    'T',
    'R',
    'L',
    'B',
    'L',
    'R',
    'R',
    'L',
    'T',	
]
export class NearRightVision extends RadioBox {
    constructor(props) {
        super(props, props.setState)
    }
	render() {
		return (
			<Translate key={this.props.template.id}>
                {({ translate }) => 
                    <tr>
                        <td colSpan="2">
                            10. {this.props.template.name}
                        </td>
                        {
                            ans.map((x, index) => 
                                <td
                                    key={index}
                                    className={`
                                        ${index+1 <= 6 ? "highlight": ''}
                                        ${index+1 === 10 ? "border-left": ''}
                                    `.trim()}
                                >
                                    <label
                                        className={this.state.value === `${index+1}` ? 'active': ''}
                                    >
                                        <input
                                            name="near-right-vision"
                                            type="radio"
                                            value={`${index+1}`}
                                            onChange={(e) => this.onChangeHandler(e)}
                                            onClick={e => this.onClickHandler(e)}
                                            checked={this.state.value === `${index+1}`}
                                        />
                                        {x}
                                    </label>
                                </td>
                            )
                        }
                        <td></td>
                    </tr>
				}
			</Translate>
		)
	}
}